import { render, staticRenderFns } from "./Finalizadas.vue?vue&type=template&id=f5cf2e2c&scoped=true"
import script from "./Finalizadas.vue?vue&type=script&lang=js"
export * from "./Finalizadas.vue?vue&type=script&lang=js"
import style0 from "./Finalizadas.vue?vue&type=style&index=0&id=f5cf2e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cf2e2c",
  null
  
)

export default component.exports